export default "__VITE_ASSET__caE$gFox__"